"use strict";
import { __exports as n } from "./index.es493.js";
var s;
function P() {
  return s ? n : (s = 1, (function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), Object.defineProperty(i, "normalizeLocalePath", {
      enumerable: !0,
      get: function() {
        return f;
      }
    });
    const u = /* @__PURE__ */ new WeakMap();
    function f(e, r) {
      if (!r) return {
        pathname: e
      };
      let t = u.get(r);
      t || (t = r.map((d) => d.toLowerCase()), u.set(r, t));
      let o;
      const c = e.split("/", 2);
      if (!c[1]) return {
        pathname: e
      };
      const l = c[1].toLowerCase(), a = t.indexOf(l);
      return a < 0 ? {
        pathname: e
      } : (o = r[a], e = e.slice(o.length + 1) || "/", {
        pathname: e,
        detectedLocale: o
      });
    }
  })(n), n);
}
export {
  P as __require
};
//# sourceMappingURL=index.es463.js.map
